(function(){"use strict";function _opt(u2){return u2+(u2.indexOf("?")>-1?"&":"?")+"width=1600&format=webp"}if(/^\/products\//.test(window.location.pathname)){var n="#7a8450",e="#2c2c2a",t="#9a9488",i="#c9a84c",a="#b8860b",o="#e8e5dc",r="#fafaf5",s="'Cormorant Garamond', Georgia, serif",l="'LINE Seed Sans', system-ui, -apple-system, sans-serif",d={39.99:{sub1:{price:33.99,strike:39.99,save:15},sub3:{price:71.98,strike:119.97,save:40},sub6:{price:119.97,strike:239.94,save:50},ot1:{price:39.99,strike:null,save:0},ot3:{price:79.98,strike:119.97,save:33},ot6:{price:143.96,strike:239.94,save:40}},34.99:{sub1:{price:29.74,strike:34.99,save:15},sub3:{price:62.98,strike:104.97,save:40},sub6:{price:104.97,strike:209.94,save:50},ot1:{price:34.99,strike:null,save:0},ot3:{price:69.98,strike:104.97,save:33},ot6:{price:125.96,strike:209.94,save:40}},27.99:{sub1:{price:23.79,strike:27.99,save:15},sub3:{price:50.38,strike:83.97,save:40},sub6:{price:83.97,strike:167.94,save:50},ot1:{price:27.99,strike:null,save:0},ot3:{price:55.98,strike:83.97,save:33},ot6:{price:100.76,strike:167.94,save:40}},114.97:{sub1:{price:80.48,strike:114.97,save:30},sub3:{price:189.7,strike:344.91,save:45},sub6:{price:310.42,strike:689.82,save:55},ot1:{price:86.23,strike:114.97,save:25},ot3:{price:206.95,strike:344.91,save:40},ot6:{price:344.91,strike:689.82,save:50}},79.98:{sub1:{price:55.99,strike:79.98,save:30},sub3:{price:131.97,strike:239.94,save:45},sub6:{price:215.95,strike:479.88,save:55},ot1:{price:59.99,strike:79.98,save:25},ot3:{price:143.96,strike:239.94,save:40},ot6:{price:239.94,strike:479.88,save:50}},95.97:{sub1:{price:67.18,strike:95.97,save:30},sub3:{price:158.35,strike:287.91,save:45},sub6:{price:259.12,strike:575.82,save:55},ot1:{price:71.98,strike:95.97,save:25},ot3:{price:172.75,strike:287.91,save:40},ot6:{price:287.91,strike:575.82,save:50}},90.97:{sub1:{price:63.68,strike:90.97,save:30},sub3:{price:150.1,strike:272.91,save:45},sub6:{price:245.62,strike:545.82,save:55},ot1:{price:68.23,strike:90.97,save:25},ot3:{price:163.75,strike:272.91,save:40},ot6:{price:272.91,strike:545.82,save:50}},55.98:{sub1:{price:39.19,strike:55.98,save:30},sub3:{price:92.37,strike:167.94,save:45},sub6:{price:151.15,strike:335.88,save:55},ot1:{price:41.99,strike:55.98,save:25},ot3:{price:100.76,strike:167.94,save:40},ot6:{price:167.94,strike:335.88,save:50}}},c={sub1:15,sub3:40,sub6:50,ot1:0,ot3:0,ot6:0},p={"glp-1-supplement":{cat:"GLP-1",formula:"10-in-1",desc:"Clinically-formulated GLP-1 support with 1500mg active blend + 1 Billion CFU probiotics."},"20-in-1-gut":{cat:"GLP-1",formula:"20-in-1",desc:"Comprehensive gut health & metabolic balance with prebiotic, probiotic & postbiotic support."},"13-in-1-magnesium":{cat:"Magnesium",formula:"13-in-1",desc:"High-absorption magnesium complex with Glycinate, L-Threonate, Malate & Citrate."},"7-in-1-magnesium":{cat:"Magnesium",formula:"7-in-1",desc:"Targeted magnesium blend for sleep, muscle, heart & nerve health."},uroplus:{cat:"Men's Health",formula:"10-in-1",desc:"Advanced urolithin A complex for cellular renewal, NAD+ and anti-aging support."},macaplus:{cat:"Performance",formula:"3-in-1",desc:"Black maca & ashwagandha blend for stamina, hormone balance & adaptogen energy."},soursop:{cat:"Detox",formula:"16-in-1",desc:"Soursop (graviola) leaf bitters with sea moss, black seed & moringa for digestion, gut cleanse & immune support."},zeolite:{cat:"Detox",formula:"8-in-1",desc:"Activated zeolite & charcoal complex for heavy metal detox, gut health & liver cleanse."},testplus:{cat:"Men's Health",formula:"8-in-1",desc:"Advanced testosterone support with tribulus, tongkat ali & turkesterone."},"vaginal-probiotic":{cat:"Women's Health",formula:"8-in-1",desc:"Vaginal probiotic gummies for intimate moisture, balanced pH & flora support."},gloplus:{cat:"Skin & Glow",formula:"11-in-1",desc:"Liposomal glutathione antioxidant complex for skin glow, radiance & detox."},shilajit:{cat:"Performance",formula:"5-in-1",desc:"Organic black shilajit with ashwagandha, tongkat ali & turkesterone for energy & vitality."},"glp-1-support-gummy":{cat:"GLP-1",formula:"4-in-1",desc:"GLP-1 support gummies with Akkermansia, Berberine & Apple Cider Vinegar."},"glp-activate":{cat:"Bundles",formula:"2-Product Bundle",desc:"GLP-1 activation & support bundle for maximum metabolic results.",isBundle:!0},"complete-weight-loss":{cat:"Bundles",formula:"3-Product Bundle",desc:"Complete weight loss & metabolism support bundle.",isBundle:!0},"metabolic-reset":{cat:"Bundles",formula:"3-Product Bundle",desc:"Full metabolic reset bundle for comprehensive wellness.",isBundle:!0},"women-s-balance":{cat:"Bundles",formula:"3-Product Bundle",desc:"Women's balance bundle for hormonal health & vitality.",isBundle:!0},"men-s-vitality":{cat:"Bundles",formula:"3-Product Bundle",desc:"Men's vitality bundle for strength, energy & performance.",isBundle:!0},"sleep-stress":{cat:"Bundles",formula:"3-Product Bundle",desc:"Sleep, stress & recovery bundle for total relaxation.",isBundle:!0},"skin-detox":{cat:"Bundles",formula:"2-Product Bundle",desc:"Skin glow & detox bundle for radiance from within.",isBundle:!0},"weight-loss-metabolism":{cat:"Bundles",formula:"2-Product Bundle",desc:"Six pharmacist-formulated formulas. 28+ clinically studied ingredients. One complete daily protocol.",isBundle:!0}},_BEN={"glp-1-gummies":{label:"MADE WITH CLINICALLY RESEARCHED INGREDIENTS",items:["Curbs cravings in a delicious daily gummy","Supports GLP-1 for natural appetite control","Reduces bloating & improves digestion","Fights inflammation with turmeric & resveratrol"]},"glp-1-synbiotic":{label:"ENGINEERED FOR TOTAL GUT HEALTH",items:["20 ingredients for complete digestive support","Reduces bloating & improves nutrient absorption","Regulates appetite & sustains energy levels","Rebuilds gut lining with pre-, pro- & postbiotics"]},"glp-1-support-capsules":{label:"MADE WITH CLINICALLY RESEARCHED INGREDIENTS",items:["Reduces hunger & controls appetite naturally","Activates your body\u2019s own GLP-1 pathways","Boosts metabolism & supports fat burning","Strengthens gut health with 1 Billion CFU probiotics"]},"glp-1-supplement":{label:"MADE WITH CLINICALLY RESEARCHED INGREDIENTS",items:["Reduces hunger & controls appetite naturally","Activates your body\u2019s own GLP-1 pathways","Boosts metabolism & supports fat burning","Strengthens gut health with 1 Billion CFU probiotics"]},"20-in-1-gut":{label:"ENGINEERED FOR TOTAL GUT HEALTH",items:["20 ingredients for complete digestive support","Reduces bloating & improves nutrient absorption","Regulates appetite & sustains energy levels","Rebuilds gut lining with pre-, pro- & postbiotics"]},"13-in-1-magnesium":{label:"13 FORMS OF MAGNESIUM IN ONE CAPSULE",items:["Improves sleep quality & helps you stay asleep","Eliminates muscle cramps & physical tension","Sharpens mental focus & reduces brain fog","Supports heart, nerve & bone health daily"]},magplus:{label:"ADVANCED SLEEP & CALM FORMULA",items:["Fall asleep faster without melatonin dependency","Quiets racing thoughts & calms nighttime anxiety","Wake up refreshed \u2014 not groggy","10x more absorbable than standard magnesium"]},testplus:{label:"CLINICALLY DOSED FOR MALE PERFORMANCE",items:["Boosts free testosterone & sex drive naturally","Builds lean muscle & speeds recovery","Increases daily energy, stamina & motivation","Lowers stress hormones that kill testosterone"]},maca:{label:"40X STRENGTH ORGANIC BLACK MACA",items:["Sustained all-day energy without caffeine or jitters","Supports libido & hormonal balance in men & women","40,000mg potency from a 40:1 concentrated extract","Builds stress resilience with adaptogenic herbs"]},urolithin:{label:"CELLULAR LONGEVITY COMPLEX",items:["Renews damaged cells & slows biological aging","Boosts NAD+ \u2014 the energy molecule that declines with age","Improves muscle endurance & reduces fatigue","Delivers maximum antioxidant protection via liposomal delivery"]},glutathione:{label:"ADVANCED SKIN & DETOX SUPPORT",items:["Brighter, more even skin tone in weeks","Master antioxidant Glutathione detoxifies from within","Reduces dark spots, dullness & visible aging","Supports liver health & immune defense daily"]},"vaginal-probiotic":{label:"CLINICALLY SHOWN TO SUPPORT PH & HORMONAL BALANCE",items:["Restores vaginal pH & healthy flora naturally","Eases PMS symptoms & supports regular cycles","Soothes bloating & intimate discomfort","Supports urinary & immune health with Vitamin C"]},"glp-1-support-gummy":{label:"MADE WITH CLINICALLY RESEARCHED INGREDIENTS",items:["Curbs cravings in a delicious daily gummy","Supports GLP-1 for natural appetite control","Reduces bloating & improves digestion","Fights inflammation with turmeric & resveratrol"]},shilajit:{label:"ANCIENT MINERAL MEETS MODERN SCIENCE",items:["Boosts testosterone, stamina & physical performance","80% Fulvic Acid for deep nutrient absorption","Sustained energy & mental clarity all day","Reduces cortisol & supports stress resilience"]},"detox-cleanse":{label:"FULL-BODY CELLULAR DETOXIFICATION",items:["Traps & removes heavy metals from your body","Deep liver cleanse with Milk Thistle & NAC","Eliminates gut toxins & reduces bloating fast","Strengthens your body\u2019s natural defense systems"]},"soursop-bitters":{label:"TRADITIONAL DIGESTIVE BITTERS, 16 BOTANICALS",items:["Feel lighter & less bloated after meals","Supports regularity & a daily gut cleanse routine","Sea moss, black seed & turmeric for detox & immune support","Orange flavor, no added sugar \u2014 a spoonful you won\u2019t dread"]},"zeolite-detox-complex":{label:"FULL-BODY CELLULAR DETOXIFICATION",items:["Activated Zeolite & Charcoal bind and flush toxins at the cellular level","Milk Thistle & NAC support liver function and antioxidant protection","Triple-action detox across gut, liver, and cellular pathways"]},"glp-activate":{label:"DUAL-ACTION GLP-1 ACTIVATION",items:["Activates GLP-1 from two different pathways","Controls appetite & cravings all day long","Rebuilds gut health with a full synbiotic complex","The natural GLP-1 stack \u2014 no prescription needed"]},"complete-weight-loss":{label:"YOUR COMPLETE WEIGHT LOSS PROTOCOL",items:["Controls hunger, cravings & late-night snacking","Resets gut health to optimize fat burning","Improves sleep \u2014 when you rest better, you lose more","Save up to 60% vs. buying each formula separately"]},"metabolic-reset":{label:"RESET YOUR METABOLISM FROM THE GROUND UP",items:["Detoxes your system before rebooting metabolism","Activates GLP-1 for natural appetite suppression","Restores deep sleep & lowers stress hormones","The full reset protocol \u2014 detox, activate, recover"]},"women-s-balance":{label:"FORMULATED FOR FEMININE VITALITY",items:["Balances hormones, mood & monthly cycles","Restores energy, libido & daily confidence","Brighter skin & stronger immune support","Complete feminine wellness in one daily stack"]},"men-s-vitality":{label:"BUILT FOR PEAK MALE PERFORMANCE",items:["Maximizes testosterone, drive & muscle growth","All-day energy & stamina without stimulants","Faster recovery & sharper mental focus","Three formulas that replace your entire supplement shelf"]},"sleep-stress":{label:"ENGINEERED FOR DEEP REST & RECOVERY",items:["Fall asleep faster & stay asleep all night","Eliminates stress, tension & racing thoughts","Repairs & detoxifies cells while you sleep","Replaces 5+ supplements with one nightly protocol"]},"skin-detox":{label:"DETOX DEEPER. GLOW BRIGHTER.",items:["Flushes heavy metals & environmental toxins","Visibly brighter, more even skin tone","Deep liver cleanse & cellular repair","Clean cells first, radiant skin follows"]},"womens-balance":{label:"COMPLETE FEMININE WELLNESS PROTOCOL",items:["Hormonal balance and cycle support","Feminine pH and microbiome support","Deep, restorative sleep without melatonin","Stress resilience and adaptogenic recovery","Energy, mood, and vitality support"]},"weight-loss-metabolism":{label:"YOUR COMPLETE WEIGHT LOSS PROTOCOL",items:["Natural appetite and metabolism support","5-layer gut microbiome optimization","Blood sugar balance support","Cellular detoxification support","Full-spectrum magnesium for recovery and energy"]}},_DESC={"glp-1-support-capsules":"Clinically researched botanicals and probiotics formulated to support healthy appetite, metabolism, and gut balance.","glp-1-supplement":"Clinically researched botanicals and probiotics formulated to support healthy appetite, metabolism, and gut balance.","glp-1-gummies":"An 8-in-1 chewable formula with Akkermansia and gut-supportive botanicals for natural GLP-1 activation.","glp-1-support-gummy":"An 8-in-1 chewable formula with Akkermansia and gut-supportive botanicals for natural GLP-1 activation.","glp-1-synbiotic":"A complete pre, pro, and postbiotic system formulated to build the gut foundation your metabolism depends on.","20-in-1-gut":"A complete pre, pro, and postbiotic system formulated to build the gut foundation your metabolism depends on.",magplus:"A liposomal magnesium complex with apigenin, L-theanine, and valerian root for deep sleep and cognitive recovery.","13-in-1-magnesium":"Thirteen forms of magnesium in one capsule, formulated for full-body recovery, sleep, and cellular energy.","totalmag-13-in-1-magnesium-complex":"Thirteen forms of magnesium in one capsule, formulated for full-body recovery, sleep, and cellular energy."};document.readyState==="loading"?document.addEventListener("DOMContentLoaded",b):setTimeout(b,100)}function v(n2,e2){return(e2||document).querySelector(n2)}function u(n2,e2){return Array.prototype.slice.call((e2||document).querySelectorAll(n2))}function f(n2){return"$"+n2.toFixed(2)}function g(n2,e2,t2){var i2=document.createElement(n2);return e2&&(i2.className=e2),t2&&(i2.innerHTML=t2),i2}function b(){var b2=window.location.pathname.replace(/\/$/,""),y=new XMLHttpRequest;y.open("GET",b2+".js",!1);try{y.send()}catch{return}if(y.status===200){var k;try{k=JSON.parse(y.responseText)}catch{return}var w=(function(n2){for(var e2=Object.keys(p),t2=0;t2<e2.length;t2++)if(n2.indexOf(e2[t2])!==-1)return p[e2[t2]];return{cat:"Supplements",formula:"",desc:"",isBundle:!1}})(k.handle),C=w.isBundle||!1,B=(k.variants[0].price/100).toFixed(2),E=d[B]||null;if(!E){var L=k.variants[0],$=L.price/100;E={},["sub1","sub3","sub6","ot1","ot3","ot6"].forEach(function(n2){var e2=c[n2]||0,t2=1,i2=$*t2,a2=i2*(1-e2/100);E[n2]={price:Math.round(100*a2)/100,strike:e2>0?Math.round(100*i2)/100:null,save:e2}}),C=!0}var O={};k.variants.forEach(function(n2){var e2=n2.title.toLowerCase();e2.indexOf("6")>-1?O[6]=n2:e2.indexOf("3")>-1?O[3]=n2:O[1]=n2}),k.variants.length===1&&(O[1]=O[3]=O[6]=k.variants[0]);var M={sub1:null,sub3:null,sub6:null};(k.selling_plan_groups||[]).forEach(function(n2){n2.name.indexOf("Subscribe")>-1&&n2.name.indexOf("Individual")===-1&&n2.selling_plans.forEach(function(n3){var e2=n3.name.toLowerCase();(e2.indexOf("every month")>-1||e2.indexOf("every 30")>-1||e2.indexOf("every 1")>-1&&e2.indexOf("every 18")===-1||e2.indexOf("1-pack 1 Month")>-1)&&(M.sub1||(M.sub1=n3.id)),(e2.indexOf("every 90")>-1||e2.indexOf("every 3")>-1&&e2.indexOf("every 30")===-1||e2.indexOf("3-pack 3 Month")>-1)&&(M.sub3||(M.sub3=n3.id)),(e2.indexOf("every 180")>-1||e2.indexOf("every 6")>-1||e2.indexOf("6-pack 6 Month")>-1)&&(M.sub6||(M.sub6=n3.id))}),n2.name.indexOf("Individual")>-1&&n2.selling_plans.forEach(function(n3){var e2=n3.name.toLowerCase();(e2.indexOf("every 30")>-1||e2.indexOf("1-pack 1 Month")>-1||e2.indexOf("1 pack 1 Month")>-1||e2.indexOf("every 1")>-1&&e2.indexOf("every 18")===-1)&&(M.sub1=n3.id),(e2.indexOf("every 90")>-1||e2.indexOf("3-pack 3 Month")>-1||e2.indexOf("3 pack 3 Month")>-1||e2.indexOf("every 3")>-1&&e2.indexOf("every 30")===-1)&&(M.sub3=n3.id),(e2.indexOf("every 180")>-1||e2.indexOf("6-pack 6 Month")>-1||e2.indexOf("6 pack 6 Month")>-1||e2.indexOf("every 6")>-1)&&(M.sub6=n3.id)})});var T=[];k.media&&k.media.length&&k.media.forEach(function(n2){n2.src&&T.push(n2.src)}),!T.length&&k.images&&k.images.length&&k.images.forEach(function(n2){T.push(n2)});var z,S={mode:"sub6",product:k,meta:w,isBundle:C,priceTier:E,variants:O,sellingPlans:M,images:T,activeImg:0};(z=document.createElement("style")).id="pdp-v2-styles",z.textContent=`
/* \u2550\u2550\u2550 PDP Redesign v2 Styles \u2550\u2550\u2550 */

@font-face {
  font-family: 'LINE Seed Sans';
  src: url('https://cdn.shopify.com/s/files/1/0927/0188/4787/files/LINESeedSans_W_Th.woff2?v=1775932673') format('woff2'),
       url('https://cdn.shopify.com/s/files/1/0927/0188/4787/files/LINESeedSans_W_Th.woff?v=1775932656') format('woff');
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'LINE Seed Sans';
  src: url('https://cdn.shopify.com/s/files/1/0927/0188/4787/files/LINESeedSans_W_Rg.woff2?v=1775932673') format('woff2'),
       url('https://cdn.shopify.com/s/files/1/0927/0188/4787/files/LINESeedSans_W_Rg.woff?v=1775932656') format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'LINE Seed Sans';
  src: url('https://cdn.shopify.com/s/files/1/0927/0188/4787/files/LINESeedSans_W_Bd.woff2?v=1775932673') format('woff2'),
       url('https://cdn.shopify.com/s/files/1/0927/0188/4787/files/LINESeedSans_W_Bd.woff?v=1775932656') format('woff');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'LINE Seed Sans';
  src: url('https://cdn.shopify.com/s/files/1/0927/0188/4787/files/LINESeedSans_W_XBd.woff2?v=1775932673') format('woff2'),
       url('https://cdn.shopify.com/s/files/1/0927/0188/4787/files/LINESeedSans_W_XBd.woff?v=1775932656') format('woff');
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'LINE Seed Sans';
  src: url('https://cdn.shopify.com/s/files/1/0927/0188/4787/files/LINESeedSans_W_He.woff2?v=1775932673') format('woff2'),
       url('https://cdn.shopify.com/s/files/1/0927/0188/4787/files/LINESeedSans_W_He.woff?v=1775932656') format('woff');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}


/* Hide original hero */
.pdp-hero { display: none !important; }
.ppu-mobile-sticky-bar { display: none !important; }

/* Container \u2014 2 column on desktop */
.v2-container {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 0;
  max-width: 1200px;
  margin: 0 auto;
  background: transparent;
  font-family: ${l};
  color: ${e};
}

.v2-left { padding: 0; position: sticky; top: 0; align-self: start; }
.v2-right { padding: 24px 32px 32px; max-width: 520px; }

/* Breadcrumb */
.v2-breadcrumb {
  padding: 12px 20px;
  font-size: 11px;
  color: ${t};
}
.v2-breadcrumb a { color: ${t}; text-decoration: none; }
.v2-breadcrumb a:hover { text-decoration: underline; }
.v2-breadcrumb span { color: ${e}; }

/* Gallery \u2014 full-bleed AG1/Huel style */
.v2-gallery {
  background: #f8f7f4;
  padding: 0;
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
}
.v2-gallery-badge {
  position: absolute;
  top: 10px; left: 10px;
  background: #2D2D2D;
  color: #fff;
  font-family: 'LINE Seed Sans', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: 999px;
  letter-spacing: 0.5px;
  z-index: 4;
  border: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  gap: 6px;
}
.v2-badge-icon { flex-shrink: 0; }
.v2-gallery-main {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  width: 100%;
  height: 100%;
}
.v2-gallery-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  display: none;
}
.v2-gallery-img.active { display: block; }
.v2-gallery-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 38px; height: 38px;
  border-radius: 50%;
  background: rgba(255,255,255,0.85);
  border: 1px solid rgba(0,0,0,0.08);
  font-size: 0;
  cursor: pointer;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2D2D2D;
  box-shadow: none;
  transition: all 0.2s;
  padding: 0;
}
.v2-gallery-arrow:hover {
  background: rgba(255,255,255,1);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
.v2-gallery-arrow svg { display: block; }
.v2-gallery-prev { left: 10px; }
.v2-gallery-next { right: 10px; }
.v2-gallery-dots {
  position: absolute;
  bottom: 12px;
  left: 12px;
  transform: none;
  display: flex;
  gap: 8px;
  z-index: 2;
}
.v2-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  background: rgba(45,45,45,0.4);
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}
.v2-dot.active {
  background: #2D2D2D;
}

/* Trust badges \u2014 REMOVED */

/* Rating */
.v2-rating { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; }
.v2-stars { font-family: 'LINE Seed Sans', system-ui, sans-serif; color: ${i}; font-size: 15px; font-weight: 400; letter-spacing: 2px; }
.v2-rating-text { font-family: 'LINE Seed Sans', system-ui, sans-serif; font-size: 13px; font-weight: 400; line-height: 1.7; color: ${t}; }
.v2-rating-text strong { font-weight: 600; color: ${e}; }

/* Title */
.v2-title {
  font-size: clamp(1.875rem, 3.5vw, 2rem);
  font-weight: 400;
  font-family: ${s};
  letter-spacing: -0.02em;
  line-height: 1.15;
  margin: 0 0 6px;
  color: #1F3D2B;
}

/* Description */
.v2-desc {
  font-size: 13px;
  color: ${t};
  line-height: 1.6;
  margin: 0 0 20px;
}

.v2-descriptor {
  font-family: 'LINE Seed Sans', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: #4E5F55;
  margin-bottom: 12px;
  max-width: 480px;
}

/* Benefits Checkmarks */
.v2-benefits-card {
  background: #ECEAE4;
  border-radius: 8px;
  max-width: 480px;
  padding: 10px 12px;
  margin: 0 0 12px;
}
.v2-benefits-label {
  font-family: 'LINE Seed Sans', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: #1F3D2B;
  margin-bottom: 8px;
}
.v2-benefits-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.v2-benefits-row:last-child {
  margin-bottom: 0;
}
.v2-benefits-row span {
  font-size: 13px;
  font-weight: 500;
  color: ${e};
  line-height: 1.3;
}
span.v2-benefit-marker {
  font-family: 'LINE Seed Sans', system-ui, sans-serif;
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #C6A96B !important;
  margin-right: 8px;
  flex-shrink: 0;
}

/* OT Buttons (restyled) */
.v2-ot-btns {
  display: flex;
  gap: 8px;
  margin: 10px 0 0;
}
.v2-ot-btn {
  flex: 1;
  position: relative;
  text-align: center;
  padding: 10px 4px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  border: 0.5px solid #d0ccc4;
  cursor: pointer;
  background: #fff;
  transition: border-color 0.15s;
}
.v2-btn-active {
  border: 1.5px solid #2B4C3F;
}
.v2-ot-badge {
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 9px;
  font-weight: 600;
  color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  white-space: nowrap;
  line-height: 1.3;
}
.v2-ot-badge-green {
  background: #2B4C3F;
}
.v2-ot-badge-gold {
  background: #C9A84C;
}

/* \u2550\u2550\u2550 BUY BOX \u2550\u2550\u2550 */

/* Subscribe card */
.v2-sub-card {
  border: 1px solid #e0ddd4;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 10px;
  max-width: 480px;
  transition: border-color 0.2s;
}
.v2-sub-card.v2-card-active { border: 2px solid ${n}; }

.v2-sub-row {
  padding: 14px 14px;
  cursor: pointer;
  background: #fff;
  transition: background 0.15s, max-height 0.3s ease, opacity 0.2s ease, padding 0.3s ease;
  overflow: hidden;
}
.v2-sub-row.v2-row-active { background: ${r}; }

.v2-row-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.v2-row-left {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
}
.v2-row-right {
  text-align: right;
  flex-shrink: 0;
  padding-left: 8px;
}
.v2-row-price { font-size: 18px; font-weight: 700; }
.v2-row-strike { font-size: 11px; font-weight: 400; color: ${t}; text-decoration: line-through; overflow: visible; white-space: nowrap; }

/* Radio dot */
.v2-radio {
  width: 20px; height: 20px;
  border-radius: 50%;
  border: 2px solid #c5c0b6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
  transition: border-color 0.15s;
}
.v2-radio.v2-radio-on[data-color="olive"] { border-color: ${n}; }
.v2-radio.v2-radio-on[data-color="dark"] { border-color: ${e}; }
.v2-radio-dot {
  width: 10px; height: 10px;
  border-radius: 50%;
  background: transparent;
  transition: background 0.15s;
}
.v2-radio.v2-radio-on[data-color="olive"] .v2-radio-dot { background: ${n}; }
.v2-radio.v2-radio-on[data-color="dark"] .v2-radio-dot { background: ${e}; }

/* Label + Badge */
.v2-row-label { min-width: 0; }
.v2-row-label-line { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.v2-label-text { font-size: 14px; font-weight: 600; }
.v2-badge {
  font-size: 9px;
  font-weight: 700;
  color: #fff;
  padding: 2px 8px;
  border-radius: 8px;
  white-space: nowrap;
}

/* Row description (expands on select) */
.v2-row-desc {
  font-size: 11px;
  font-weight: 400;
  color: ${t};
  line-height: 1.5;
  margin-top: 4px;
  display: none;
}
.v2-row-active .v2-row-desc { display: block; }

.v2-row-border { height: 1px; background: ${o}; margin: 0; }

/* Add to Cart buttons */
.v2-atc {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  cursor: pointer;
  margin-bottom: 12px;
  color: #fff;
  transition: opacity 0.15s;
}
.v2-atc:hover { opacity: 0.9; }
.v2-atc:disabled { opacity: 0.6; cursor: not-allowed; }
.v2-atc-sub { background: ${n}; }
.v2-atc-ot { background: ${n}; }

/* One-Time card */
.v2-ot-card {
  border: 1px solid #e0ddd4;
  border-radius: 14px;
  overflow: hidden;
  max-width: 480px;
  margin-bottom: 10px;
  transition: border-color 0.2s;
}
.v2-ot-card.v2-card-active { border: 2px solid ${e}; }

.v2-ot-header {
  padding: 10px 14px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.v2-ot-left { display: flex; gap: 10px; align-items: center; }

/* OT quantity pills */
.v2-ot-btns {
  display: flex;
  gap: 6px;
  padding: 0 16px 14px;
}
.v2-ot-btn {
  flex: 1;
  padding: 8px 4px;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  border: 1.5px solid #d5d0c6;
  background: #fff;
  transition: all 0.15s;
}
.v2-ot-btn.v2-btn-active {
  border: 2px solid ${e};
  background: #fafafa;
}
.v2-pill-label { font-size: 11px; font-weight: 600; }
.v2-pill-badge { font-size: 9px; color: ${t}; margin-top: 1px; }
.v2-btn-active .v2-pill-badge { color: ${e}; }

/* Subscription benefits */
.v2-sub-benefits {
  display: none !important; /* Subscription benefits box removed \u2014 April 1, 2026 */
}
.v2-benefits-title { font-family: 'LINE Seed Sans', system-ui, sans-serif; font-size: 13px; font-weight: 600; margin-bottom: 10px; }
.v2-benefit {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  font-family: 'LINE Seed Sans', system-ui, sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #4a4a4a;
}
.v2-benefit-icon { display: flex; align-items: center; justify-content: center; width: 24px; height: 24px; flex-shrink: 0; }
.v2-benefit-icon svg { display: block; }

/* Trust row */
.v2-trust-row { display: none !important;
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 6px;
  padding-bottom: 4px;
}
.v2-trust-row > span {
  font-size: 10px;
  color: ${t};
  display: flex;
  align-items: center;
  gap: 3px;
}
.v2-trust-check { color: ${n}; }

/* Sticky bar */
.pdp-v2-sticky {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid ${o};
  padding: 10px 16px;
  z-index: 999;
  transform: translateY(100%);
  transition: transform 0.3s;
}
.v2-sticky-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1280px;
  margin: 0 auto;
}
.v2-sticky-name { font-size: 16px; color: #1C1C1C; font-weight: 600; letter-spacing: 0.5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 55vw; }
.v2-sticky-ppb { font-size: 13px; color: #1C1C1C; font-weight: 500; margin-top: 2px; line-height: 1.2; }
.v2-sticky-price { display: flex; align-items: baseline; gap: 6px; }
.v2-sticky-amount { font-size: 18px; font-weight: 700; }
.v2-sticky-strike { font-size: 11px; color: ${t}; text-decoration: line-through; }
.v2-sticky-btn {
  padding: 10px 24px;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.v2-sticky-sub { background: ${n}; }
.v2-sticky-ot { background: ${e}; }

/* \u2550\u2550\u2550 MOBILE \u2550\u2550\u2550 */
@media (max-width: 767px) {
  .v2-container {
    grid-template-columns: 1fr;
  }
  .v2-left { margin: 0 -16px; width: calc(100% + 32px); }
  .v2-right { padding: 16px; max-width: none; }
  .v2-title { font-size: 22px; }
  .v2-gallery {
    aspect-ratio: 1 / 1;
    width: 100%;
    border-radius: 0;
  }
  .v2-breadcrumb { margin: 0 16px; }

  /* Benefits card mobile */
  .v2-benefits-card { padding: 10px 12px; margin: 0 0 10px; }
  .v2-benefits-label { font-size: 11px; margin-bottom: 8px; }
  .v2-benefits-row { gap: 8px; margin-bottom: 8px; }
  .v2-benefits-row span { font-size: 12px; }
  .v2-check-circle { width: 16px; height: 16px; min-width: 16px; }
  .v2-check-circle svg { width: 8px; height: 8px; }
  /* OT buttons mobile */
  .v2-ot-btns { gap: 6px; }
  .v2-ot-btn { padding: 8px 2px; font-size: 13px; border-radius: 6px; }
  .v2-ot-badge { font-size: 8px; padding: 1px 6px; top: -7px; }
  /* Sub benefits below fold mobile */
  .v2-sub-benefits { margin-top: 24px; }

  /* Mobile delivery label single-line fix */
  .v2-badge { padding-left: 6px; padding-right: 6px; }
  .v2-label-text { white-space: nowrap; font-size: 13px; }
  .v2-row-label-line { flex-wrap: nowrap; }
}

/* \u2550\u2550\u2550 TABLET \u2550\u2550\u2550 */

@media (min-width: 768px) {
  .v2-container {
    align-items: start;
  }
  .v2-left {
    align-self: auto;
    display: flex;
    flex-direction: column;
    min-height: 780px !important;
  }
  .v2-gallery {
    flex: 1;
    aspect-ratio: auto;
    background: #004B31;
  }
  .v2-gallery-main {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
  }
  .v2-gallery-img {
    object-position: center top;
  }
  .v2-gallery-main img {
    object-fit: cover !important;
    aspect-ratio: auto !important;
    object-position: center top !important;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .v2-container {
    grid-template-columns: 1fr 1fr;
    gap: 0;
  }
  .v2-right { padding: 20px; }
}

.pu-trust-bar{display:flex;align-items:flex-start;justify-content:flex-start;gap:10px;width:100%;max-width:100%;padding:14px 0;border-top:1px solid rgba(44,44,42,0.07);border-bottom:1px solid rgba(44,44,42,0.07);background:#fff;box-sizing:border-box;}
.pu-trust-icon{font-size:18px;line-height:1;color:#C9A96E;flex-shrink:0;display:inline-block;margin-top:1px;}
.pu-trust-content{flex:1 1 auto;min-width:0;}
.pu-trust-items{font-family:'LINE Seed Sans',system-ui,-apple-system,sans-serif;font-size:10px;font-weight:400;color:#2c2c2a;letter-spacing:0.03em;line-height:1.4;white-space:nowrap;}
.pu-trust-item{display:inline;}
.pu-trust-dot{display:inline;color:#C9A96E;margin:0 6px;font-weight:700;}
.pu-trust-sub{font-family:'LINE Seed Sans',system-ui,-apple-system,sans-serif;font-size:9px;font-weight:400;color:#9a9488;line-height:1.45;margin-top:4px;letter-spacing:0.01em;}
@media (max-width:768px){.pu-trust-bar{padding:12px 0;gap:8px;}.pu-trust-icon{font-size:16px;margin-top:0;}.pu-trust-items{font-size:9px;white-space:normal;}.pu-trust-sub{font-size:9px;}}
.v2-atc-ot, .v2-sticky-ot { background-color: #2B4C3F !important; }
.v2-atc[style*='display:none'] + .pu-trust-bar, .v2-atc[style*='display: none'] + .pu-trust-bar { display: none !important; }

/* \u2550\u2550\u2550 Cross-Module Width & Color Fixes \u2550\u2550\u2550 */

/* Fix 1: Ingredient tiles \u2014 match other accordion body text color + animation */
.pdp-ingredient-tile.pdp-ingredient-tile.pdp-ingredient-tile {
  background: linear-gradient(168deg, rgb(42,77,53) 0%, rgb(31,61,43) 50%, rgb(26,51,37) 100%) !important;
  border-top: none !important;
  padding: 20px 18px !important;
}
.pdp-ingredient-tile-name.pdp-ingredient-tile-name.pdp-ingredient-tile-name {
  color: rgb(107, 103, 92) !important;
}
.pdp-ingredients-item.active .pdp-ingredient-tile-name.pdp-ingredient-tile-name.pdp-ingredient-tile-name {
  color: #FFFFFF !important;
}
.pdp-ingredient-tile-role.pdp-ingredient-tile-role.pdp-ingredient-tile-role {
  color: rgb(107, 103, 92) !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 1.4 !important;
}
.pdp-ingredients-item.active .pdp-ingredient-tile-role.pdp-ingredient-tile-role.pdp-ingredient-tile-role {
  color: rgb(196, 162, 101) !important;
}
.pdp-ingredient-tile:hover .pdp-ingredient-tile-name.pdp-ingredient-tile-name.pdp-ingredient-tile-name {
  color: #FFFFFF !important;
}
.pdp-ingredient-tile:hover .pdp-ingredient-tile-role.pdp-ingredient-tile-role.pdp-ingredient-tile-role {
  color: rgb(43, 76, 63) !important;
}

/* Fix 1b: Ingredient grid desktop width */
@media (min-width: 768px) {
  .pdp-why-right {
    width: 650px;
  }
  .pdp-ingredient-grid {
    width: 646px;
  }
}

/* Fix 2: Real Results reviews section \u2014 match 1200px content width */
.ppu-reviews-section {
  max-width: 1200px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

/* Fix 3: FAQ section \u2014 match 1200px content width */
.pu-faq-section {
  max-width: 1200px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

/* ═══ Section heading standardization ═══ */

/* Eyebrow labels */
.pdp-why-eyebrow-text.pdp-why-eyebrow-text,
.pbt-eyebrow.pbt-eyebrow {
  font-family: 'LINE Seed Sans', system-ui, sans-serif !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  letter-spacing: 0.15em !important;
  text-transform: uppercase !important;
  color: #1F3D2B !important;
}

/* Section headings */
.pdp-why-headline,
.pbt-heading,
.cs-intro {
  font-family: 'Cormorant Garamond', Georgia, serif !important;
  font-size: clamp(1.8rem, 3vw, 2.8rem) !important;
  font-weight: 500 !important;
  line-height: 1.2 !important;
  color: #1F3D2B !important;
}

/* Italic emphasis within headings */
.pdp-why-headline em,
.pbt-heading em,
.cs-intro em {
  font-style: italic !important;
  font-weight: 500 !important;
}

/* Descriptor/subtext below headings */
.pdp-why-subcopy.pdp-why-subcopy,
.pbt-sub.pbt-sub,
.cs-paragraph.cs-paragraph {
  font-family: 'LINE Seed Sans', system-ui, sans-serif !important;
  font-size: 15px !important;
  font-weight: 400 !important;
  line-height: 1.6 !important;
  color: #1F3D2B !important;
}

/* FAQ brand typography (doubled selectors to beat Liquid template specificity) */
.pu-faq-eyebrow.pu-faq-eyebrow {
  font-family: 'LINE Seed Sans', system-ui, sans-serif !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  letter-spacing: 0.15em !important;
  text-transform: uppercase !important;
  color: #1F3D2B !important;
}
.pu-faq-heading.pu-faq-heading {
  font-family: 'Cormorant Garamond', Georgia, serif !important;
  font-weight: 500 !important;
  color: #1F3D2B !important;
}
.pu-faq-question.pu-faq-question {
  font-family: 'LINE Seed Sans', system-ui, sans-serif !important;
  font-weight: 400 !important;
  font-size: 15px !important;
  color: #1F3D2B !important;
}
.pu-faq-answer-inner.pu-faq-answer-inner,
.pu-faq-answer-inner.pu-faq-answer-inner p {
  font-family: 'LINE Seed Sans', system-ui, sans-serif !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #1F3D2B !important;
}


`,document.head.appendChild(z);var A=v(".pdp-hero");if(A){A.style.display="none";var P=v(".ppu-mobile-sticky-bar");P&&(P.style.display="none");var j=g("section","pdp-hero-v2");j.innerHTML=(function(e2){var t2=e2.priceTier,o2=e2.meta,r2=e2.product.title,s2=r2,l2='<div class="v2-breadcrumb"><a href="/collections/all">Shop All</a> / <a href="/collections/all">'+o2.cat+"</a> / <span>"+r2.split(" ").slice(0,3).join(" ")+"</span></div>",d2='<div class="v2-gallery">';d2+='<div class="v2-gallery-badge">\u{1F525} BESTSELLER</div>',d2+='<button class="v2-gallery-arrow v2-gallery-prev" data-dir="prev"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2D2D2D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',d2+='<button class="v2-gallery-arrow v2-gallery-next" data-dir="next"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2D2D2D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg></button>',d2+='<div class="v2-gallery-main">',e2.images.forEach(function(n2,e3){d2+='<img src="'+_opt(n2)+'" alt="'+r2+'"'+(e3!==0?' loading="lazy"':' loading="eager" fetchpriority="high"')+' class="v2-gallery-img'+(e3===0?" active":"")+'" data-idx="'+e3+'">'}),d2+="</div>",d2+='<div class="v2-gallery-dots">',e2.images.forEach(function(n2,e3){d2+='<div class="v2-dot'+(e3===0?" active":"")+'" data-idx="'+e3+'"></div>'}),d2+="</div></div>";var _revEl=document.querySelector('.psp-agg-count'),_revCount=_revEl?_revEl.textContent.trim().match(/(\d[\d,]+)/):null,_revLabel=_revCount?'<a href="#ppu-reviews-section" style="color:#1F3D2B;text-decoration:underline">'+_revCount[1]+' Reviews</a>':'<a href="#ppu-reviews-section" style="color:#1F3D2B;text-decoration:underline">3,700+ Reviews</a>';var c2='<div class="v2-rating"><span class="v2-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span> <span class="v2-rating-text"><strong>'+_revLabel+'</strong></span></div>',p2='<h1 class="v2-title">'+s2+"</h1>",w2=(function(){var hdl=e2.product.handle,dt=_DESC[hdl];if(!dt){var metaDesc=o2.desc||"";if(metaDesc){var firstSent=metaDesc.match(/^[^.!?]+[.!?]/);dt=firstSent?firstSent[0]:metaDesc}}return dt?'<p class="v2-descriptor">'+dt+"</p>":""})(),v2=(function(){for(var hdl=e2.product.handle,bn=null,bk=Object.keys(_BEN),i2=0;i2<bk.length;i2++)if(hdl.indexOf(bk[i2])!==-1){bn=_BEN[bk[i2]];break}if(!bn)return'<p class="v2-desc">'+(o2.desc||"")+"</p>";var h3='<div class="v2-benefits-card"><p class="v2-benefits-label">Benefits*</p>';return bn.items.forEach(function(it){h3+='<div class="v2-benefits-row"><span class="v2-benefit-marker">+</span><span>'+it+"</span></div>"}),h3+"</div>"})(),u2=(e2.isBundle,{sub1:"Monthly Delivery",sub3:"3-Month Delivery",sub6:"6-Month Delivery"}),g2={sub1:n,sub3:i,sub6:a},b3='<div class="v2-sub-card v2-card-active" data-card="sub">';["sub1","sub3","sub6"].forEach(function(n2){var e3=t2[n2],i2=n2==="sub6";b3+='<div class="v2-sub-row'+(n2==="sub6"?" v2-row-active":"")+'" data-mode="'+n2+'">',b3+='<div class="v2-row-top">',b3+='<div class="v2-row-left">',b3+='<div class="v2-radio'+(n2==="sub6"?" v2-radio-on":"")+'" data-color="olive"><div class="v2-radio-dot"></div></div>',b3+='<div class="v2-row-label">',b3+='<div class="v2-row-label-line"><span class="v2-label-text">'+u2[n2]+"</span>",b3+='<span class="v2-badge" style="background:'+g2[n2]+'">SAVE '+e3.save+"%</span></div>",b3+='<div class="v2-row-desc">'+(function(n3){return{sub1:"1-month supply, ships every 30 days \u2022 Cancel anytime",sub3:"3-month supply, ships every 90 days",sub6:"6-month supply, ships every 180 days"}[n3]||""})(n2)+"</div>",b3+="</div></div>",b3+='<div class="v2-row-right"><div class="v2-row-price">'+f(e3.price)+"</div>",e3.strike&&(b3+='<div class="v2-row-strike">'+f(e3.strike)+"</div>"),b3+="</div></div>",i2||(b3+='<div class="v2-row-border"></div>'),b3+="</div>"}),b3+="</div>";var h2='<button class="v2-atc v2-atc-sub" data-action="atc">Add to Cart &rarr; '+f(t2.sub3.price)+"</button><div class='pu-trust-bar' aria-label='Trust bar'><span class='pu-trust-icon' aria-hidden='true'>\u2695</span><div class='pu-trust-content'><div class='pu-trust-items'><span class='pu-trust-item'>30-day risk-free guarantee</span><span class='pu-trust-dot'>\xB7</span><span class='pu-trust-item'>Free Shipping</span></div><div class='pu-trust-sub'>Clinically researched ingredients made in the USA and third-party tested for potency.</div></div></div>",m2='<div class="v2-sub-benefits"><div class="v2-benefits-title">Your subscription includes:</div><div class="v2-benefit"><span class="v2-benefit-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2B4C3F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="12" width="15" height="8" rx="1"/><path d="M16 16h4l3-3v-1h-7"/><circle cx="5.5" cy="20" r="1.5"/><circle cx="18.5" cy="20" r="1.5"/><path d="M1 12V9a1 1 0 0 1 1-1h13"/></svg></span> Free shipping always</div><div class="v2-benefit"><span class="v2-benefit-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2B4C3F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="10" y1="9" x2="10" y2="15"/><line x1="14" y1="9" x2="14" y2="15"/></svg></span> Pause, skip, or cancel anytime &mdash; no fees</div><div class="v2-benefit"><span class="v2-benefit-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2B4C3F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/><path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"/></svg></span> Auto-ships on your schedule</div><div class="v2-benefit"><span class="v2-benefit-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2B4C3F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg></span> 30-day money-back guarantee</div></div>',x2='<div class="v2-ot-card" data-card="ot">';x2+='<div class="v2-ot-header" data-mode="ot3">',x2+='<div class="v2-ot-left">',x2+='<div class="v2-radio" data-color="dark"><div class="v2-radio-dot"></div></div>',x2+='<span class="v2-label-text">One-Time</span></div>',x2+='<div class="v2-row-right"><div class="v2-row-price v2-ot-price">'+f(t2.ot3.price)+"</div>",t2.ot3.strike&&(x2+='<div class="v2-row-strike v2-ot-strike">'+f(t2.ot3.strike)+"</div>"),x2+="</div></div>",x2+='<div class="v2-ot-btns" style="display:none">',(e2.isBundle?[["ot1","1\xD7 bundle","SAVE "+t2.ot1.save+"%","green"],["ot3","3\xD7 bundle","SAVE "+t2.ot3.save+"%","green"],["ot6","6\xD7 bundle","SAVE "+t2.ot6.save+"%","gold"]]:[["ot1","1 bottle",null,null],["ot3","3 bottles",location.pathname.indexOf("bundle")>-1?"SAVE "+t2.ot3.save+"%":"BUY 2 GET 1","green"],["ot6","6 bottles","SAVE "+t2.ot6.save+"%","gold"]]).forEach(function(n2){var id=n2[0],lbl=n2[1],badge=n2[2],bc=n2[3];x2+='<div class="v2-ot-btn'+(id==="ot1"?" v2-btn-active":"")+'" data-mode="'+id+'">',badge&&(x2+='<div class="v2-ot-badge v2-ot-badge-'+bc+'">'+badge+"</div>"),x2+=lbl+"</div>"}),x2+="</div></div>";var y2='<button class="v2-atc v2-atc-ot" data-action="atc" style="display:none">Add to Cart &mdash; '+f(t2.ot3.price)+"</button><div class='pu-trust-bar' aria-label='Trust bar'><span class='pu-trust-icon' aria-hidden='true'>\u2695</span><div class='pu-trust-content'><div class='pu-trust-items'><span class='pu-trust-item'>30-day risk-free guarantee</span><span class='pu-trust-dot'>\xB7</span><span class='pu-trust-item'>Free Shipping</span></div><div class='pu-trust-sub'>Clinically researched ingredients made in the USA and third-party tested for potency.</div></div></div>";return'<div class="v2-container"><div class="v2-left">'+l2+d2+'</div><div class="v2-right">'+p2+c2+w2+v2+'<div class="v2-buybox" id="purchase-module">'+b3+h2+x2+y2+'<div class="v2-trust-row"><span><span class="v2-trust-check">&#x2713;</span> Secure Checkout</span><span><span class="v2-trust-check">&#x2713;</span> 60-Day Guarantee</span><span><span class="v2-trust-check">&#x2713;</span> Free Shipping</span></div></div>'+m2+"</div></div>"})(S),A.parentElement.insertBefore(j,A),(function(n2,e2){u(".v2-sub-row",e2).forEach(function(t3){t3.addEventListener("click",function(){var t4=this.dataset.mode;n2.mode=t4,h(n2,e2)})});var t2=v(".v2-ot-header",e2);t2&&t2.addEventListener("click",function(){var t3=n2.mode.startsWith("ot")?n2.mode:"ot3";n2.mode=t3,h(n2,e2)}),u(".v2-ot-btn",e2).forEach(function(t3){t3.addEventListener("click",function(t4){t4.stopPropagation(),n2.mode=this.dataset.mode,h(n2,e2)})}),u(".v2-gallery-arrow",e2).forEach(function(t3){t3.addEventListener("click",function(t4){t4.stopPropagation();var i2=this.dataset.dir,a2=n2.images.length;n2.activeImg=i2==="prev"?(n2.activeImg-1+a2)%a2:(n2.activeImg+1)%a2,m(n2,e2)})}),u(".v2-dot",e2).forEach(function(t3){t3.addEventListener("click",function(){n2.activeImg=parseInt(this.dataset.idx),m(n2,e2)})}),u("[data-action='atc']",e2).forEach(function(e3){e3.addEventListener("click",function(){x(n2)})})})(S,j);var D,H,F=g("div","pdp-v2-sticky");F.innerHTML=(H=(D=S).priceTier.sub6,'<div class="v2-sticky-inner"><div class="v2-sticky-info"><div class="v2-sticky-name">'+(function(t){var p=(t||"").split(/\s+/);for(var i=1;i<p.length;i++){if(p[i].indexOf("-in-")>-1){return p[i-1]+" "+p[i]}}return t||""})(D.product.title)+'</div><div class="v2-sticky-ppb" data-ppb>'+((H&&H.price!=null)?('$'+(Number(H.price)/6).toFixed(2)+' per bottle'):'')+'</div></div><button class="v2-sticky-btn v2-sticky-sub" data-action="atc">Start Now</button></div>'),document.body.appendChild(F),requestAnimationFrame(function(){var rr=document.querySelector('.v2-sub-row[data-mode="sub6"] .v2-row-price');var pp=F.querySelector('[data-ppb]');if(rr&&pp){var nn=parseFloat(rr.textContent.replace(/[^\d.]/g,""));if(!isNaN(nn)&&nn>0){pp.textContent='$'+(nn/6).toFixed(2)+' per bottle';}}}),(function(n2,e2){var t2=v("[data-action='atc']",e2);t2&&t2.addEventListener("click",function(){x(n2)});var i2=v(".v2-buybox");i2&&new IntersectionObserver(function(n3){n3.forEach(function(n4){e2.style.transform=n4.isIntersecting?"translateY(100%)":"translateY(0)"})},{threshold:0}).observe(i2)})(S,F)}}}function h(n2,e2){var t2=n2.mode,i2=t2.startsWith("sub"),a2=n2.priceTier,o2=a2[t2],r2=v(".v2-sub-card",e2),s2=v(".v2-ot-card",e2);r2.classList.toggle("v2-card-active",i2),s2.classList.toggle("v2-card-active",!i2),u(".v2-sub-row",e2).forEach(function(n3){var e3=n3.dataset.mode,i3=t2===e3;n3.classList.toggle("v2-row-active",i3),v(".v2-radio",n3).classList.toggle("v2-radio-on",i3);var a3=v(".v2-row-desc",n3);a3&&(a3.style.display=i3?"block":"none")}),u(".v2-sub-row",e2).forEach(function(n3,idx){if(idx>0){if(i2){(function(el){setTimeout(function(){el.style.padding="14px 14px";el.style.maxHeight="200px";el.style.opacity="1";el.style.overflow="visible";setTimeout(function(){el.style.maxHeight="none"},400)},300)})(n3)}else{n3.style.maxHeight="0";n3.style.opacity="0";n3.style.overflow="hidden";n3.style.padding="0 14px"}}}),(function(){var fr=u(".v2-sub-row",e2)[0];if(fr){var bg=v(".v2-badge",fr);if(bg){bg.textContent=i2?"SAVE 15%":"SAVE UP TO 50%";if(i2){bg.style.removeProperty("background");bg.style.removeProperty("color");bg.style.removeProperty("border")}else{bg.style.setProperty("background","#1F3D2B","important");bg.style.setProperty("color","#FFFFFF","important");bg.style.setProperty("border","1px solid #1F3D2B","important")}}}}()),v(".v2-ot-card .v2-radio",e2).classList.toggle("v2-radio-on",!i2),v(".v2-ot-btns",e2).style.display=i2?"none":"flex",i2||u(".v2-ot-btn",e2).forEach(function(n3){n3.classList.toggle("v2-btn-active",n3.dataset.mode===t2)});var l2=a2[i2?"ot3":t2],d2=v(".v2-ot-price",e2),c2=v(".v2-ot-strike",e2);d2&&(d2.textContent=f(l2.price)),c2&&(l2.strike?(c2.textContent=f(l2.strike),c2.style.display="block"):c2.style.display="none");var p2=v(".v2-atc-sub",e2),g2=v(".v2-atc-ot",e2);p2.style.display=i2?"block":"none",g2.style.display=i2?"none":"block",i2?p2.innerHTML="Add to Cart &rarr; "+f(o2.price):g2.innerHTML="Add to Cart &mdash; "+f(o2.price),v(".v2-sub-benefits",e2).style.display=i2?"block":"none";var b2=v(".v2-sticky-amount"),h2=v(".v2-sticky-strike"),m2=v(".v2-sticky-btn");b2&&(b2.textContent=f(o2.price)),h2&&(o2.strike?(h2.textContent=f(o2.strike),h2.style.display="inline"):h2.style.display="none"),m2&&(m2.className="v2-sticky-btn "+(i2?"v2-sticky-sub":"v2-sticky-ot"))}function m(n2,e2){u(".v2-gallery-img",e2).forEach(function(e3){e3.classList.toggle("active",parseInt(e3.dataset.idx)===n2.activeImg)}),u(".v2-dot",e2).forEach(function(e3){e3.classList.toggle("active",parseInt(e3.dataset.idx)===n2.activeImg)})}function x(n2){var e2=n2.mode,t2=e2.startsWith("sub"),i2={sub1:"1",sub3:"3",sub6:"6",ot1:"1",ot3:"3",ot6:"6"}[e2],a2=n2.variants[i2];if(a2){var o2={items:[{id:a2.id,quantity:n2.isBundle?parseInt(i2):1}]};if(t2){var r2=n2.sellingPlans[e2];r2&&(o2.items[0].selling_plan=r2,n2.isBundle&&(o2.items[0].properties={_mode:"subscribe",_purchase_type:"subscribe",_frequency:i2==="1"?"30":i2==="3"?"90":"180"}))}else n2.isBundle&&(o2.items[0].properties={_pack_size:i2+"-Pack"});u(".v2-atc, .v2-sticky-btn").forEach(function(n3){n3.disabled=!0,n3.textContent="Adding..."});var s2=new XMLHttpRequest;s2.open("POST","/cart/add.js",!0),s2.setRequestHeader("Content-Type","application/json"),s2.onload=function(){if(u(".v2-atc, .v2-sticky-btn").forEach(function(n3){n3.disabled=!1}),s2.status===200){u(".v2-atc, .v2-sticky-btn").forEach(function(n3){n3.textContent="Added"}),setTimeout(function(){var e4=n2.priceTier[n2.mode],t4=v(".v2-atc-sub"),i4=v(".v2-atc-ot");t4&&(t4.innerHTML="Add to Cart &rarr; "+f(e4.price)),i4&&(i4.innerHTML="Add to Cart &mdash; "+f(e4.price));var a3=v(".v2-sticky-btn");a3&&(a3.textContent="Add to Cart")},1500);var e3=document.querySelector("#cartDrawer");if(e3&&e3.classList){e3.classList.add("open");var t3=document.querySelector("#cartDrawerOverlay");t3&&t3.classList.add("open")}try{var i3=new XMLHttpRequest;i3.open("GET","/cart.js",!0),i3.onload=function(){var n3=JSON.parse(i3.responseText);document.querySelectorAll(".cart-count, .cart-badge, [data-cart-count]").forEach(function(e4){e4.textContent=n3.item_count})},i3.send()}catch{}}else u(".v2-atc, .v2-sticky-btn").forEach(function(n3){n3.textContent="Error \u2014 Try Again"})},s2.send(JSON.stringify(o2))}else alert("Variant not available")}})(),(function(){var CSS=".ppu-atc-group{position:relative;border-radius:8px;overflow:hidden;margin:0 0 10px 0;max-width:480px;box-shadow:0 2px 10px rgba(43,76,63,0.22);}.ppu-atc-group .v2-atc{width:100%;height:46px;border-radius:0 !important;margin:0 !important;box-shadow:none !important;display:flex !important;align-items:center;justify-content:center;font-weight:600;font-size:15px;letter-spacing:0.02em;background:#2b4c3f !important;color:#fff !important;border:0;}.ppu-atc-group .v2-atc:hover{background:#2f5446 !important;opacity:1;}.ppu-atc-divider{height:1px;background:rgba(255,255,255,0.12);width:100%;}.ppu-atc-trust-strip{background:#2b4c3f;padding:6px 14px;cursor:pointer;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;user-select:none;transition:background 0.15s;}.ppu-atc-trust-strip:hover{background:#2f5446;}.ppu-atc-trust-line{display:flex;align-items:center;justify-content:center;gap:8px;color:#fff;font-family:'LINE Seed Sans',system-ui,-apple-system,sans-serif;font-size:11px;font-weight:500;letter-spacing:0.02em;line-height:1.3;text-align:center;}.ppu-atc-trust-icon{flex-shrink:0;display:inline-flex;}.ppu-atc-trust-items{display:inline;white-space:nowrap;}.ppu-atc-trust-dot{color:#C9A96E;margin:0 6px;font-weight:700;}.ppu-atc-trust-sub{color:#C9A96E;font-family:'LINE Seed Sans',system-ui,-apple-system,sans-serif;font-size:9px;font-weight:400;letter-spacing:0.02em;line-height:1.3;text-align:center;opacity:0.95;}@media (max-width:767px){.ppu-atc-group .v2-atc{height:48px;font-size:15px;}.ppu-atc-trust-strip{padding:10px 10px 12px;gap:3px;}.ppu-atc-trust-line{font-size:11px;gap:6px;flex-wrap:wrap;}.ppu-atc-trust-items{white-space:normal;}.ppu-atc-trust-sub{display:none;}}.pu-trust-bar,.v2-trust-row,.v2-breadcrumb{display:none !important;}",SVG='<svg class="ppu-atc-trust-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="3" x2="12" y2="21"></line><path d="M7 7 Q12 10 17 7"></path><path d="M7 11 Q12 14 17 11"></path><path d="M7 15 Q12 18 17 15"></path><path d="M9 4 Q12 6 15 4"></path></svg>';function buildTrust(){var d=document.createElement("div");return d.className="ppu-atc-trust-strip",d.setAttribute("role","presentation"),d.innerHTML='<div class="ppu-atc-trust-line">'+SVG+'<span class="ppu-atc-trust-items"><span>30-day risk-free guarantee</span><span class="ppu-atc-trust-dot">\xB7</span><span>Free Shipping</span></span></div><div class="ppu-atc-trust-sub">Clinically researched ingredients \xB7 Made in the USA \xB7 Third-party tested</div>',d}function wrapButton(btn){if(!(!btn||btn.closest(".ppu-atc-group"))){var group=document.createElement("div");group.className="ppu-atc-group",btn.style.display==="none"&&(group.style.display="none"),btn.parentNode.insertBefore(group,btn),group.appendChild(btn);var divider=document.createElement("div");divider.className="ppu-atc-divider",group.appendChild(divider);var trust=buildTrust();trust.addEventListener("click",function(e){e.target.closest(".v2-atc")||(e.preventDefault(),btn.click())}),group.appendChild(trust);try{var mo=new MutationObserver(function(){group.style.display=btn.style.display==="none"?"none":""});mo.observe(btn,{attributes:!0,attributeFilter:["style"]})}catch{}}}function cleanupOld(){for(var bars=document.querySelectorAll(".pu-trust-bar, .v2-trust-row"),i=0;i<bars.length;i++)bars[i].parentNode&&bars[i].parentNode.removeChild(bars[i])}function init(){if(!document.getElementById("ppu-atc-group-css")){var s=document.createElement("style");s.id="ppu-atc-group-css",s.textContent=CSS,document.head.appendChild(s)}var sub=document.querySelector(".v2-atc-sub"),ot=document.querySelector(".v2-atc-ot");sub&&wrapButton(sub),ot&&wrapButton(ot),cleanupOld()}function tryInit(){return document.querySelector(".v2-atc-sub")||document.querySelector(".v2-atc-ot")?(init(),!0):!1}if(!tryInit())var t=0,iv=setInterval(function(){t++,(tryInit()||t>50)&&clearInterval(iv)},150);try{var bo=new MutationObserver(function(){document.querySelector(".ppu-atc-group")?document.querySelector(".pu-trust-bar, .v2-trust-row")&&cleanupOld():tryInit()});bo.observe(document.body,{childList:!0,subtree:!0})}catch{}})(),(function(){var GRAY="rgb(107, 103, 92)",GOLD="rgb(196, 162, 101)",DURATION=1800;function cleanLiquidOverrides(){for(var sheets=document.styleSheets,i=sheets.length-1;i>=0;i--)try{for(var rules=sheets[i].cssRules,j=rules.length-1;j>=0;j--){var sel=rules[j].selectorText||"";(sel===".pdp-ingredient-tile-name.pdp-ingredient-tile-name"||sel===".pdp-ingredient-tile-desc.pdp-ingredient-tile-desc")&&rules[j].style&&rules[j].style.getPropertyPriority("color")==="important"&&sheets[i].deleteRule(j)}}catch{}}function animateIngredientColors(item,toActive){var WHITE="#FFFFFF";var names=item.querySelectorAll(".pdp-ingredient-tile-name"),roles=item.querySelectorAll(".pdp-ingredient-tile-role");names.forEach(function(el){el.getAnimations().forEach(function(a){a.cancel()});el.animate([{color:toActive?GRAY:WHITE},{color:toActive?WHITE:GRAY}],{duration:DURATION,easing:"ease-in-out",fill:"forwards"})});roles.forEach(function(el){el.getAnimations().forEach(function(a){a.cancel()});el.animate([{color:toActive?GRAY:GOLD},{color:toActive?GOLD:GRAY}],{duration:DURATION,easing:"ease-in-out",fill:"forwards"})})}function initIngredientAnim(){cleanLiquidOverrides();var items=document.querySelectorAll(".pdp-ingredients-item");return items.length?(items.forEach(function(item){var observer=new MutationObserver(function(mutations){mutations.forEach(function(m){if(m.attributeName==="class"){var isActive=item.classList.contains("active");animateIngredientColors(item,isActive)}})});observer.observe(item,{attributes:!0,attributeFilter:["class"]})}),!0):!1}var attempts=0,iv=setInterval(function(){(initIngredientAnim()||++attempts>30)&&clearInterval(iv)},500)})();

;(function(){function updateRevCount(){var el=document.querySelector('.psp-agg-count');if(!el)return false;var m=el.textContent.trim().match(/(\d[\d,]+)/);if(!m)return false;var target=document.querySelector('.v2-rating-text strong');if(target&&target.textContent.indexOf('600,000')>-1){target.textContent=m[1]+' Satisfied Customers'}return true}if(!updateRevCount()){var _ro=new MutationObserver(function(){if(updateRevCount())_ro.disconnect()});_ro.observe(document.body,{childList:true,subtree:true});setTimeout(function(){_ro.disconnect()},15000)}
function initSubCardHeight(){var rows=document.querySelectorAll(".v2-sub-row");if(!rows.length)return false;var sc=document.querySelector(".v2-sub-card");var isSub=sc&&sc.classList.contains("v2-card-active");rows.forEach(function(r,idx){if(idx>0){if(isSub){r.style.padding="14px 14px";r.style.maxHeight="200px";r.style.opacity="1";r.style.overflow="visible"}else{r.style.maxHeight="0";r.style.opacity="0";r.style.overflow="hidden";r.style.padding="0 14px"}}});return true}if(!initSubCardHeight()){var _scObs=new MutationObserver(function(){if(initSubCardHeight())_scObs.disconnect()});_scObs.observe(document.body,{childList:true,subtree:true});setTimeout(function(){_scObs.disconnect()},15000)}



// Fix START YOUR PROTOCOL link
var _protLink=document.querySelector(".pdp-risk-free-cta");if(_protLink){_protLink.addEventListener("click",function(ev){ev.preventDefault();window.scrollTo({top:0,behavior:"smooth"})})}


// Force ingredient styles - names white, roles gold with asterisks
function forceIngredientStyles(){if(window.innerWidth<768)return;document.querySelectorAll(".pdp-ingredient-tile-name").forEach(function(el){el.style.setProperty("color","#FFFFFF","important");el.style.setProperty("font-size","13px","important")});document.querySelectorAll(".pdp-ingredient-tile-role").forEach(function(el){el.style.setProperty("color","#C6A96B","important");el.style.setProperty("font-size","12px","important");el.style.setProperty("font-weight","400","important");el.style.setProperty("line-height","1.4","important");if(el.textContent.trim().slice(-1)!=="*")el.textContent=el.textContent.trim()+"*"})}
document.addEventListener("DOMContentLoaded",forceIngredientStyles);setTimeout(forceIngredientStyles,500);setTimeout(forceIngredientStyles,1200);setTimeout(forceIngredientStyles,3000);

})();
//# sourceMappingURL=/s/files/1/0927/0188/4787/t/129/assets/pdp-redesign.js.map?v=1775933335967
